module.exports = __webpack_public_path__ + "img/kool-london.808c243e.png";